import React from 'react';
import classnames from 'classnames';
import { OverlayDropdown } from './OverlayDropdown';
import { SellerNameDisplay } from './SellerNameDisplay';
import { SubCategoryDisplay } from './SubCategoryDisplay';
import classes from './OverlayActions.module.scss';

interface OverlayActionsProps {
  sellerUserName: string;
  gigSlug: string;
  subCategoryName: string;
  onGigLinkClick: () => void;
  onSellerLinkClick: () => void;
}

export const OverlayActions = ({
  sellerUserName,
  gigSlug,
  subCategoryName,
  onGigLinkClick,
  onSellerLinkClick,
}: OverlayActionsProps) => {
  return (
    <div className={classnames(classes.container, 'flex flex-between flex-items-center')}>
      <div className="co-white tbody-6">
        <SubCategoryDisplay subCategoryName={subCategoryName} />
        <br />
        <SellerNameDisplay sellerUserName={sellerUserName} onClick={onSellerLinkClick} />
      </div>
      <OverlayDropdown sellerUserName={sellerUserName} gigSlug={gigSlug} onGigLinkClick={onGigLinkClick} />
    </div>
  );
};
